/* eslint-disable */
export default {
  start: 'Realizar una visita rápida',
  skip: 'Omitir',
  next: 'Siguiente',
  finish: 'Finalizar',
} as const;

// @key: @#@"start"@#@ @source: @#@"Take a quick tour"@#@
// @key: @#@"skip"@#@ @source: @#@"Skip"@#@
// @key: @#@"next"@#@ @source: @#@"Next"@#@
// @key: @#@"finish"@#@ @source: @#@"Finish"@#@
